import moment from 'moment';

export const formatRemainingTime = (date: Date) => {
  const days = moment(date).diff(moment(), 'days');
  const hours = moment(date).subtract(days, 'days').diff(moment(), 'hours');
  const minutes = moment(date)
    .subtract(days, 'days')
    .subtract(hours, 'hours')
    .diff(moment(), 'minutes');
  if (days >= 0 && hours >= 0 && minutes >= 0) {
    return `${days} jours ${hours} heures ${minutes} minutes`;
  } else {
    return 'Dépassé';
  }
};
